import React, { useRef, useState } from "react";
import { useDispatch } from 'react-redux';

import {
    Dialog,
    Button,
    Typography,
    IconButton,
} from "@material-tailwind/react";
import SignaturePad from "react-signature-canvas";

import {
    Xmark
} from "iconoir-react";

import {
    Vehicle,
    updateVehicleRequest,
} from "../redux/vehicles/actions";


interface DialogVehicleDeliveryConfirmationProps {
    vehicle: Vehicle | null;
    isOpen: boolean;
    setIsOpen: (flag: any) => void;
}

export const DialogVehicleDeliveryConfirmation: React.FC<DialogVehicleDeliveryConfirmationProps> = ({
    vehicle,
    isOpen,
    setIsOpen,
}) => {
    const dispatch = useDispatch();
    const sigPadRef = useRef<SignaturePad>(null);
    const [isEmpty, setIsEmpty] = useState(true);

    const handleClear = () => {
        sigPadRef.current?.clear();
        setIsEmpty(true);
    };

    const handleConfirm = () => {
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            const data = {
                ...vehicle,
                delivery_date: new Date().toISOString(),
                signature: sigPadRef.current.toDataURL("image/png"),
            };

            dispatch(updateVehicleRequest({vehicle: data as Vehicle, update_fields: ['id', 'delivery_date', 'signature']}));

            setIsOpen(false);
        } else {
            alert("Please provide a signature.");
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Overlay>
                <Dialog.Content className="p-8 max-w-lg">
                    <div className="text-center text-[#1F2937] mb-2">
                        <Typography as="h2" className="text-md font-bold">
                            Signature
                        </Typography>
                        <Dialog.DismissTrigger
                            as={IconButton}
                            size="sm"
                            variant="ghost"
                            color="secondary"
                            className="!absolute right-2 top-2"
                            isCircular
                        >
                            <Xmark className="h-5 w-5" />
                        </Dialog.DismissTrigger>
                    </div>

                    <div className="relative h-64 border border-gray-300 bg-gray-50">
                        <SignaturePad
                            ref={sigPadRef}
                            onEnd={() => setIsEmpty(sigPadRef.current?.isEmpty() as boolean)}
                            canvasProps={{
                                className: "w-full h-full",
                            }}
                        />
                    </div>

                    <div className="mt-5 flex justify-between">
                        <Button
                            onClick={handleClear}
                            size="sm"
                            variant="outline"
                            color="secondary"
                            className="self-start justify-self-start"
                        >
                            Clear
                        </Button>
                        <div className="flex gap-2">
                            <Dialog.DismissTrigger
                                as={Button}
                                variant="ghost"
                                color="error"
                            >
                                Cancel
                            </Dialog.DismissTrigger>
                            <Button
                                color="primary"
                                disabled={isEmpty}
                                onClick={handleConfirm}
                            >
                                Confirm
                            </Button>
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Overlay>
        </Dialog>
    );
}
